<template>
  <div>
    <v-row>
      <!-- datepicker 2 -->
      <v-col cols="4">
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              dense
              outlined
              single-line
              v-model="record.StartDate"
              label="From"
              prepend-icon="mdi-calendar-month"
              v-on="on"
              readonly
            ></v-text-field>
          </template>
          <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
        </v-menu>
      </v-col>

      <!-- datepicker 2 -->
      <v-col cols="4">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              dense
              outlined
              single-line
              v-model="record.EndDate"
              label="To"
              prepend-icon="mdi-calendar-month"
              v-on="on"
              readonly
            ></v-text-field>
          </template>
          <v-date-picker  v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="4">
        <v-btn  :loading="loader" @click="getReport" color="accent">Generate Report</v-btn>
      </v-col>

      <v-col cols="2">
        <v-btn icon @click="printDoc">
          <v-icon>mdi-printer</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="text--primary subtitle-2">
      <v-col cols="3">
        <v-row dense>
          <v-col cols="12">
            <span>Total Sales Value: {{reportData.TotalSalesAmount}}</span>
          </v-col>
          <v-col cols="12">
            <span>Cost Of Goods: {{reportData.CostOfGoods}}</span>
          </v-col>
          <v-col cols="12">
            <span>Gross Profit: {{reportData.TotalGrossProfit}}</span>
          </v-col>
          <v-col cols="12">
            <span>Total Expenditure: {{reportData.TotalExpenditure}}</span>
          </v-col>

          <v-col cols="12">
            <span>Outsourced Profit: {{reportData.outSourcedProfit}}</span>
          </v-col>
          
          <v-col cols="12">
            Profit/Loss:
            <span
              v-if="reportData.TotalNetProfit"
            >{{(parseFloat(reportData.TotalNetProfit.split(',').join('')) + parseFloat(reportData.outSourcedProfit.split(',').join(''))).toLocaleString()}}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    },
  },
  data() {
    return {
      record: {},
      loader: false,
      search: null,
      menu1: false,
      menu2: false,
      reportData: {},
      headers: [
        { text: "Description", value: "Description" },
        { text: "Amount", value: "Amount" },
        { text: "Date", value: "DocDate" },
      ],
    };
  },
  methods: {
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    getReport() {
      const data = this.record;
      const url = "/pnl-report";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.reportData = res.ResponseData;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(() => {
        });
    },
    printDoc() {
      if (this.record.StartDate == null || this.record.EndDate == null) {
        this.$refs.snackbar.show("Please select both dates", "red");
      } else {
        this.print();
      }
    },
    print() {
      const shopName = this.storeName;
      var doc = new jsPDF({ compress: true });
      // var pageHeight =
      //   doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      var pageWidth =
        doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

      var img = new Image();
      img.src = require("@/assets/stock.png");
      doc.addImage(img, "png", 10, 5, 100, 40);

      doc.setFontSize(15);
      doc.setTextColor(0, 0, 0);
      doc.setFont("Georgia, serif");
      doc.text(shopName, pageWidth - 50, 15, "center");

      //Setting Items Title
      doc.setFontSize(15);
      doc.text("Profit And Loss Report", pageWidth / 2, 57, "center");

      doc.setFontSize(13);
      doc.text(
        `From: ${this.record.StartDate}  To:  ${this.record.EndDate}`,
        pageWidth / 2,
        62,
        "center"
      );
      doc.setFontSize(12);

      // Vairables to Hold Data
      let dataSummaryRows = [];

      function dataSummaryColumns() {
        return [
          {
            count: "",
            name: "Amount",
          },
        ];
      }

      const TotalSalesAmount = {
        count: "Total Sales Amount",
        name: this.reportData.TotalSalesAmount.toLocaleString(),
      };

      const CostOfGoods = {
        count: "Cost of Goods",
        name: this.reportData.CostOfGoods.toLocaleString(),
      };

      const TotalGrossProfit = {
        count: "Gross Profit",
        name: this.reportData.TotalGrossProfit.toLocaleString(),
      };

      const TotalOutsourcedProfit = {
        count: "Outsourced Profit",
        name: this.reportData.outSourcedProfit.toLocaleString(),
      };

      const TotalExpenditure = {
        count: "Total Expenditure",
        name: this.reportData.TotalExpenditure.toLocaleString(),
      };

      const totalProfit = (parseFloat(this.reportData.TotalNetProfit.split(',').join('')) + parseFloat(this.reportData.outSourcedProfit.split(',').join(''))).toLocaleString();

      const TotalNetProfit = {
        count: "Net Profit",
        name: totalProfit.toLocaleString(),
      };
      
      dataSummaryRows.push(TotalSalesAmount);
      dataSummaryRows.push(CostOfGoods);
      dataSummaryRows.push(TotalGrossProfit);
      dataSummaryRows.push(TotalOutsourcedProfit);
      dataSummaryRows.push(TotalExpenditure);
      dataSummaryRows.push(TotalNetProfit);

      doc.setTextColor(0, 0, 0);
      doc.setFontSize(11);
      doc.setFont("Georgia, serif");
      doc.text("SUMMARY", 15, 68);
      doc.autoTable({
        head: dataSummaryColumns(),
        body: dataSummaryRows,
        theme: "grid",
        tableWidth: 100,
        columnStyles: {
          count: {
            fontStyle: "bold",
          },
        },
        startY: 70,
        styles: { overflow: "hidden", cellPadding: 1, font: "Georgia, serif" },
        margin: { right: 100 },
      });

      doc.save("PNL-report.pdf");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>